<template>
	<div class="pt-3">
		<v-row justify="center">
			<v-col cols="12" md="12" class="text-right py-0">
				<v-btn text small  class="mr-2"  @click="openDialog" v-if="retailer_details.is_registered_user" > 
					<span class="secodry-text-2 ">{{$lang.MERGE}}</span>		
				</v-btn>
				<v-btn text small    
				@click="$router.push({name:'edit-retailer',params:{retailer_id:encript(retailer_id)}})"
				> 
				<span class="secodry-text-2 pr-1">{{$lang.EDIT}}</span>		
				<img src="@/assets/edit.svg" alt="img">
			</v-btn>
		</v-col>
	</v-row>
	<v-row justify="start">
		<v-col cols="6" md="4">
			<div class="mb-5">
				<p class="page-title fs-16 fw-bold text-left"> {{$lang.NAME}}</p>
				<p class="secondary-text">{{ retailer_details.retailer_firm_name }}</p>
			</div>
			<div class="mb-5" v-if="retailer_details.retailer_mobile_number">
				<p class="page-title fs-16 fw-bold text-left"> {{$lang.PHONE_NUMBER}}</p>
				<p class="secondary-text">{{ retailer_details.retailer_mobile_number }}</p>
			</div>
			<div class="mb-5" v-if="retailer_details.retailer_landline_number">
				<p class="page-title fs-16 fw-bold text-left"> {{$lang.LANDLINE_NO}}</p>
				<p class="secondary-text">{{ retailer_details.retailer_landline_number }}</p>
			</div>
			<div class="mb-5" v-if="retailer_details.retailer_email">
				<p class="page-title fs-16 fw-bold text-left"> {{$lang.EMAIL_ID}}</p>
				<p class="secondary-text">{{ retailer_details.retailer_email }}</p>
			</div>
			<div class="mb-5" v-if="retailer_details.retailer_shop_number">
				<p class="page-title fs-16 fw-bold text-left"> {{$lang.SHOP_NO}}</p>
				<p class="secondary-text">{{ retailer_details.retailer_shop_number }}</p>
			</div>
			<div class="mb-5">
				<p class="page-title fs-16 fw-bold text-left"> {{$lang.FULL_ADDRESS}}</p>
				<p class="secondary-text">{{ retailer_details.retailer_full_address }}</p>
			</div>
			<div class="mb-5">
				<p class="page-title fs-16 fw-bold text-left"> {{$lang.PIN_CODE}}</p>
				<p class="secondary-text">{{ retailer_details.retailer_pincode }}</p>
			</div>
			<div class="mb-5">
				<p class="page-title fs-16 fw-bold text-left"> {{$lang.AREA}}</p>
				<p class="secondary-text">{{ retailer_details.retailer_location }}</p>
			</div>
			<div class="mb-5">
				<p class="page-title fs-16 fw-bold text-left"> {{$lang.CITY}}</p>
				<p class="secondary-text">{{ retailer_details.retailer_city }}, {{ retailer_details.retailer_state }}</p>
			</div>
		</v-col>
		<!-- BLANK DATA -->
		<v-col cols="6" md="1" class="border-r">
		</v-col>
		<!--  -->
		<v-col cols="6" md="5" class="pl-6">
			<!-- <div class="mb-5">
				<p class="page-title fs-16 fw-bold text-left"> {{$lang.LOCATION}}</p>
				<p class="secondary-text">{{ retailer_details.retailer_firm_name }}</p>
			</div> -->
			<div class="mb-5">
				<p class="page-title fs-16 fw-bold text-left"> {{$lang.LINE}}</p>
				<p class="secondary-text">{{ retailer_details.line_name }}</p>
			</div>
			<div class="mb-5" v-if="retailer_details.retailer_gst_number">
				<p class="page-title fs-16 fw-bold text-left"> {{$lang.GST_NUMBER}}</p>
				<p class="secondary-text">{{ retailer_details.retailer_gst_number }}</p>
			</div>
			<div  class="mb-5" >
				<p class="page-title fs-16 fw-bold text-left"> {{$lang.ACCESS}}</p>
				<div class="d-flex flex-row pt-0 m-t-negative-10"  >
					<div class="pt-4">
						<span class="secondary-text" v-if="retailer_details.is_active">{{$lang.ENABLED}} </span>
						<span class="secondary-text" v-if="!retailer_details.is_active">{{$lang.DISABLED}} </span>
					</div>
					<div class="pl-3">
						<v-switch color="primary"
						v-model="retailer_details.is_active"
						:ripple="false" 
						class="custome-toggle-btn" 
						:class="retailer_details.is_active?'active-toggle-btn':'deactive-toggle-btn'" inset 
						@click="ChangeRetailerVerificationStatus"></v-switch>
					</div>
				</div>
			</div>
			<div>
				<img :src="retailer_details.retailer_image" alt="" width="100%" class="cursor-pointer"  @click="previewImage">
			</div>

		</v-col>
	</v-row>

	<image-viewer :image_src="retailer_details.retailer_image"/>


	<merge-with-dialog :dialog="dialog"  ref="merge_retailer_dialog" :retailer_id="retailer_id" @update-data="updateData"/>
</div>
</template>
<script type="text/javascript">
export default{
	components:{
		ImageViewer :()=>import('@/components/common-components/ImageViewer.vue'),
		MergeWithDialog:()=>import('./child/MergeWithDialog')
	},
	data(){
		return{
			retailer_id:"",
			retailer_details:{
				retailer_firm_name:"",
				retailer_mobile_number:"",
				retailer_landline_number:"",
				retailer_email:"",
				retailer_full_address:"",
				retailer_shop_number:"",
				retailer_pincode:"",
				city:"",
				state:"",
				retailer_gst_number:"",
				retailer_latitude:120.24545,
				retailer_longitude:24.315645,
				retailer_image:""
			},
			dialog:{
				flag:false,
			}

		}
	},
	created(){

		if (this.$route.params.retailer_id){
			this.retailer_id= this.decrypt(this.$route.params.retailer_id)
			this.getRetailerDetails()
		} 
	},
	methods:{
		/* Fetch Retailer data */ 
		getRetailerDetails(){
			const self=this
			this.$store.dispatch('setPageLoader', true)

			let params={
				retailer_id:self.retailer_id
			};
			self.table_loading=true

			const successHandler = (response) => {
				if (response.data.success){
					this.retailer_details=response.data.data
				}
			};
			const finallyHandler = () => {
				self.table_loading=false
				this.$store.dispatch('setPageLoader', false)
			};

			self.request_GET( self,self.$urls.RETAILER_PROFILE,params,successHandler,null,null,finallyHandler)
		},
		/* Preview image */ 
		previewImage(){
			this.$store.dispatch('setImageViewer',true)
		},
		/* CAccess enable disable for reatiler */
		ChangeRetailerVerificationStatus(){
			const self=this;
			this.$store.dispatch('setPageLoader', true)
			var	form = new FormData();
			let  is_active="False"
			if(self.retailer_details.is_active)
				is_active="True"

			form.append("retailer_id",self.retailer_id);
			form.append("is_active",is_active);

			const successHandler = (response) => {
				if (response.data.success){
					this.getRetailerDetails()
				}
			};
			const finallyHandler = () => {
				this.$store.dispatch('setPageLoader', false)
			};
			
			this.request_POST(self,this.$urls.CHANGE_RETAILER_VERIFICATION_STATUS,form,successHandler,null,null,finallyHandler)
		},
		openDialog(){
			this.dialog.flag=true
			this.$refs.merge_retailer_dialog.getRetailerList()
		},
		updateData(retailer_id){
			this.retailer_id=retailer_id
			this.getRetailerDetails()
		}
	}

}

</script>